import { render, staticRenderFns } from "./UploadFile.vue?vue&type=template&id=cc07e4bc&scoped=true"
import script from "./UploadFile.vue?vue&type=script&setup=true&lang=ts"
export * from "./UploadFile.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./UploadFile.vue?vue&type=style&index=0&id=cc07e4bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc07e4bc",
  null
  
)

export default component.exports